import { DevicesChartProps } from './devices-chart.props';

export const DevicesChartPresets: Partial<DevicesChartProps> = {
  devices: [],
};
